/**
 *
 * Asynchronously loads the component for PaymentTransaction
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
